import { render, staticRenderFns } from "./bindemaildialog.vue?vue&type=template&id=91c91638&scoped=true"
import script from "./bindemaildialog.vue?vue&type=script&lang=js"
export * from "./bindemaildialog.vue?vue&type=script&lang=js"
import style0 from "./bindemaildialog.vue?vue&type=style&index=0&id=91c91638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c91638",
  null
  
)

export default component.exports